<template lang="pug">
  .find-countries
    .section
      .container.has-text-centered
        h1(v-if="!employer") {{gettext('The country in which you want to work')}}
        h1(v-else) {{gettext('From which country do you want to hire workers?')}}
          .dotted-line.left
          .dotted-line.right
        .field.is-horizontal.controls-field
          div
            label.label
              span {{ gettext('Choose country:') }}
              .field-body
                ajax-dropdown(
                :labelText="gettext('Choose country')"
                :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: !employer ? ['for_employer_profile'] : []}}",
                :itemName ="'name'"
                :option="gettext('All countries')"
                @updated="next($event.id)"
                )
          div
            a.main-btn.col-white.bg-gray.next(@click="next()") {{gettext('Skip')}}
        .blocks-wrap
          .column(v-for="(country, key) in countries" )
            a.img-wrap(@click="next(country.id)")
              .overlay
              .country
                .img-bg(v-if="country.image" :style="{ 'background-image': 'url(' + country.image + ')'}")
                .img-bg(v-else)
                span {{ country.name }}
        .field.is-horizontal
          .field-body
            .main-btn.bg-transparent(@click="more = !more" v-if="allCountries.length > countriesLimit") {{ !more ? gettext('Show more') : gettext('Show less') }}
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {gettext} from '@/services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import mixin from '@/mixins'
const _ = require('lodash')

export default {
  name: 'FindCountries',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      query: {},
      allCountries: [],
      more: false,
      employer: false,
      countriesLimit: 9
    }
  },
  created () {
    this.setData()
  },
  components: {
    AjaxDropdown
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveCountries'
    ]),
    setData () {
      this.query = this.$route.query
      if (!this.query.search) {
        if (this.$auth.check()) {
          this.employer = this.getUser.profile_type === 20
          this.query.search = this.getUser.profile_type === 20 ? 'workers' : 'job'
        } else {
          this.query.search = 'job'
        }
      }
      this.receiveCountries({lang: this.getLanguage, filters: !this.employer ? ['for_employer_profile'] : []}).then(res => {
        this.allCountries = _.sortBy(res, ['id', 'for_jobseeker_profile', 'for_employer_profile'])
      })
    },
    next (country) {
      this.$router.push({name: 'FindCategories', params: {lang: this.getLanguage}, query: Object.assign(this.query, {country: country})})
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Find for country'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    countries: function () {
      if (this.more) return this.allCountries
      return this.allCountries.slice(0, this.countriesLimit)
    }
  },
  watch: {
    getLanguage: function () {
      this.setData()
    }
  }
}
</script>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/find/countries/index.vue